var map = {
	"./File_001.jpeg": 6,
	"./arrow.svg": 7,
	"./digital.jpg": 39,
	"./divider.jpg": 40,
	"./foiling.jpg": 41,
	"./logo.svg": 4,
	"./main.jpeg": 5,
	"./roller.jpg": 42,
	"./way.jpeg": 8
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.(jpe?g|png|gif|svg|png)$/
// module id = 38
// module chunks = 0